import RouteModel from "../model-factory/basic/route/RouteModel";
import {FactoryID, RouteKey} from "../model-factory/type-interface/ModelFactoryType";
import RouteFactory from "../model-factory/basic/route/RouteFactory";
import RouteChoice from "../model-factory/basic/route/RouteChoice";
import {IRouteIDs} from "../model-factory/type-interface/ModelFactoryInterface";

export class SubPageRouteModel extends RouteModel
{

    navigationRouteKey: RouteKey = "sub_page_route_id";

    createChoiceOrder(): string[]|null
    {

        if(this.populateIDs.browse_route_id === "site_pages"){
            return ["cookie_policy", "accessibility", "privacy_policy"];
        }
        return [];
    }
}

export default class SubPageRouteFactory extends RouteFactory
{

    id: FactoryID = "sub_page_route";

    constructor()
    {
        super();

        this.choices = {
            cookie_policy: new RouteChoice({
                name: "Cookie Policy",
                pageID: "cookie_policy"
            }),
            accessibility: new RouteChoice({
                name: "Accessibility",
                pageID: "accessibility"
            }),
            privacy_policy: new RouteChoice({
                name: "Privacy Policy",
                pageID: "privacy_policy"
            }),
        }
    }

    birth(id: FactoryID): SubPageRouteModel
    {
        return new SubPageRouteModel(id);
    }

    getDefaultModel(browse_route_id:string): SubPageRouteModel | null
    {
        let routeIDs:IRouteIDs = {
            browse_route_id: browse_route_id,
        }
        return this.getDefaultModelWithRoute(routeIDs)! as SubPageRouteModel;
    }
}